import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
		primary: '#537131',
    secondary: '#593622',
    accent: '#F2C730',
	}
})
